import designAssistant from './designAssistant';

const assistants = { designAssistant };

export default assistants;
